import type { MarketDataSnapshot } from '../../../types/MarketDataSnapshot';

export function isMarketDataValid(symbol: string, marketData?: MarketDataSnapshot): marketData is MarketDataSnapshot {
  if (!marketData) {
    return false;
  }

  if (marketData.Symbol !== symbol) {
    return false;
  }

  const hasBidsArray = Array.isArray(marketData.Bids);
  const hasOffersArray = Array.isArray(marketData.Offers);

  return hasBidsArray && hasOffersArray;
}
